import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,MatSortModule } from '@angular/material';
import { SecDatatable } from '../../models/datatable.model';
import { AppService } from '../../services/app.service';
import { SharedService } from '../../services/shared';


@Component({
  selector: 'app-secondary-datatable',
  templateUrl: './secondary-datatable.component.html',
  styleUrls: ['./secondary-datatable.component.scss']
})
export class SecondaryDatatableComponent implements OnInit {
  @Input() parent: any;
  @Output() add = new EventEmitter();
  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() customeClick = new EventEmitter();
  @Output() getPageWiseData = new EventEmitter();
  @Output() getFilteredData = new EventEmitter();
  @Output() getSortedData = new EventEmitter();
  
  resultsLength = 0;
  isRateLimitReached = false;
  displayedColumns = [];
  public parentData;
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  length:number = 0;
  
  constructor(private datatableProp: SecDatatable, public appService: AppService,private sharedService: SharedService) {
      this.appService.checkSession();
      this.sharedService.documnetData.subscribe( value => {
          this.dataSource = new MatTableDataSource(value);
      });
  }
  
  ngOnInit() {
      this.setTableData();
  }
  setTableData(){
      this.appService.showLoading();
  
      this.displayedColumns = this.datatableProp.displayedColumns;
      let colIndex = 0;
  
  
      if (this.datatableProp.isEdit) {
          var edit = this.datatableProp.displayedColumns.filter(d => d == 'Edit');
          if(edit.length == 0){
              this.datatableProp.displayedColumns.splice(colIndex, 0, 'Edit');
              colIndex++;
          }
      }
  
      if (this.datatableProp.isDelete) {
          var deleteRes = this.datatableProp.displayedColumns.filter(e => e == 'Delete');
          if(deleteRes.length == 0){
              this.datatableProp.displayedColumns.splice(colIndex, 0, 'Delete');
              colIndex++;
          }
      }
      if (this.datatableProp.iscustom) {
          for (let i = 0; i < this.datatableProp.gridControl.length; i++) {
              var customRes = this.datatableProp.displayedColumns.filter(e => e == this.datatableProp.gridControl[i].Name);
              if(customRes.length == 0){                                                            
                  this.datatableProp.displayedColumns.splice(colIndex, 0, this.datatableProp.gridControl[i].Name);
                  colIndex++;
              }
          }
      }
     
      this.dataSource = new MatTableDataSource(this.parent.documnetData);
      this.parentData = this.parent.documnetData;
      this.appService.hideLoading();
  }
  addRecord() {
      this.appService.showLoading();
      this.add.emit();
  }
  
  editRecord(e) {
      this.appService.showLoading();
      this.edit.emit(e);
  }
  
  deleteRecord(e) {
      this.delete.emit(e);
  }
  customRecord(e, type: Number) {
      this.customeClick.emit(e);
  }
  ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this._updatePaginator(this.parent.length, this.parent.pageSize, this.parent.pageIndex);
  }
  
  applyFilter(filterValue: string) {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
      //this.dataSource.filter = filterValue;
      this.getFilteredData.emit(filterValue);
  }
  
  isCustomColumn(columnName) {
      if (this.datatableProp.iscustom){
          return (this.datatableProp.displayedColumns.indexOf(columnName) > -1 && this.datatableProp.gridControl.some(function (o) { return o["Name"] === columnName; }));
      }
      else{
          return false;
      } 
  }
  
  getCustomControProp(name,prop){
      for (let i = 0; i < this.datatableProp.gridControl.length; i++) {
          if(this.datatableProp.gridControl[i].Name == name){
              return this.datatableProp.gridControl[i][prop];
          }
      }
  }
  
  getServerData(event){
      this.getPageWiseData.emit(event);
  }
  
  _updatePaginator(filteredDataLength: number, pageSize: number, pageIndex: number) { 
      Promise.resolve().then(() => { 
          if (!this.paginator) { return; } 
  
          this.paginator.length = filteredDataLength; 
  
          // If the page index is set beyond the page, reduce it to the last page. 
          if (pageIndex > 0) { 
              const lastPageIndex = Math.ceil(this.paginator.length / pageSize) - 1 || 0; 
              this.paginator.pageIndex = Math.min(pageIndex, lastPageIndex); 
          } 
      }); 
  } 
  
  sortData(event, i){
      this.parent.sortDirection = event.direction;
      this.parent.sortHeaderName = event.active;
  }
  getColumnDetails(event){
      this.getSortedData.emit(event);
  }
  }
  



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/secondary-datatable/secondary-datatable.component.ts